import config from '../config';

export function getImageUrl(image) {
  if (image.startsWith('http')) {
    return image;
  }

  return `${config.mediaUrl}${image}`;
}
